import { request } from './http'
import type { GenreTemplate } from '@/types/nf'

interface GenreTemplateListResponse {
  templates: GenreTemplate[] | null
}

export const genreTemplateApi = {
  list: async (): Promise<GenreTemplate[]> => {
    const data = await request<GenreTemplateListResponse>('/v1/genre-templates')
    return data.templates ?? []
  },

  getByGenre: (key: string): Promise<GenreTemplate> =>
    request<GenreTemplate>(`/v1/genre-templates/${encodeURIComponent(key)}`),
}
